<template>
	<div>
		<FunctionTitle :title="mainTitle" />
		<CommonFlame :title="pageTitle">
			<template v-if="!$vuetify.breakpoint.xs" v-slot:app-bar-btn>
				<v-btn v-if="!showSearchForm" color="primary" dark @click="back()"
					><i class="fas fa-undo"></i>検索へ戻る</v-btn
				>
				<v-btn color="primary" dark @click="openRubberCustomerCompanyIndexDialog"
					><v-icon>mdi-table</v-icon> ゴム生地適合表</v-btn
				>
			</template>
			<template v-if="$vuetify.breakpoint.xs">
				<v-row no-gutters justify="end" class="mb-2">
					<v-btn v-if="!showSearchForm" color="secondary" dark @click="back()"
						><i class="fas fa-undo"></i>検索へ戻る</v-btn
					>
				</v-row>
				<v-row no-gutters justify="end" class="mb-2">
					<v-btn color="secondary" dark @click="openRubberCustomerCompanyIndexDialog"
						><v-icon>mdi-table</v-icon> ゴム生地適合表</v-btn
					>
				</v-row>
			</template>
			<RubberStockSearchForm
				v-if="showSearchForm"
				:month.sync="month"
				:title="search_title"
				@send-parent="searchRubberStock"
			/>
			<template v-if="!showSearchForm">
				<span class="attention" v-if="$vuetify.breakpoint.xs"
					>※在庫一覧表はPCもしくはタブレットで使用してください
				</span>
				<div class="month">表示月：{{ currentMonth | monthFormatter }}</div>
				<v-container class="search-content-area">
					<v-row no-gutters class="my-1"><p style="font-size: 1.15rem">検索内容</p></v-row>
					<v-row no-gutters class="my-1">
						<v-col cols="12" sm="3" v-if="q.name_cont">
							<v-card outlined
								><v-card-subtitle>ゴム生地名</v-card-subtitle><v-divider class="mx-3"></v-divider
								><v-card-title class="subtitle-1">{{ q.name_cont }} を含む</v-card-title>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
				<template v-if="!loading">
					<div class="receiving-shipping-area">
						<div class="d-flex">
							<!-- Todo 見出し列を固定したときのレイアウトが崩れる -->
							<v-checkbox v-model="fixed" class="mt-3 ml-2" label="見出し列を固定"></v-checkbox>
							<v-spacer></v-spacer>
							<v-btn color="calendar-btn" class="mr-2" @click="previousMonth()">
								<v-icon>mdi-chevron-left</v-icon>先月</v-btn
							>
							<v-btn color="calendar-btn" class="mr-2" @click="nextMonth()"
								>翌月<v-icon>mdi-chevron-right</v-icon></v-btn
							>
						</div>
						<div class="table-area">
							<table>
								<tr class="top">
									<th :class="['main-color', { 'sticky-01': fixed, 'not-sticky-01': !fixed }]">
										ゴム生地名
									</th>
									<th :class="['main-color', { 'sticky-02': fixed, 'not-sticky-02': !fixed }]">
										先月繰越
									</th>
									<th
										v-if="isBeforeToday"
										:class="['main-color', { 'sticky-03': fixed, 'not-sticky-03': !fixed }]"
									>
										{{ stock }}
									</th>
									<th
										v-if="isBeforeToday"
										:class="['main-color', { 'sticky-04': fixed, 'not-sticky-04': !fixed }]"
									>
										月末在庫数(見込み)
									</th>
									<th :class="['main-color', { 'sticky-05': fixed, 'not-sticky-05': !fixed }]">
										入出庫合計
									</th>
									<th :class="['main-color', { 'sticky-06': fixed, 'not-sticky-06': !fixed }]">
										入出庫合計(見込み)
									</th>
									<th :class="['main-color', { 'sticky-07': fixed, 'not-sticky-07': !fixed }]">
										入出庫
									</th>

									<th v-for="date in scheduleDates" :key="date.id">
										{{ date | dateFormatter }}
									</th>
								</tr>
								<tbody v-for="rubber in rubbers" :key="rubber.id">
									<tr>
										<td
											@click="openRubberShowDialog(rubber)"
											rowspan="2"
											:class="{ 'sticky-01': fixed, 'not-sticky-01': !fixed }"
											style="cursor: pointer"
										>
											{{ rubber.name }}
										</td>
										<!-- 先月繰越 -->
										<td rowspan="2" :class="{ 'sticky-02': fixed, 'not-sticky-02': !fixed }">
											{{ rubberCarryOver(rubber.id) }}
										</td>
										<!-- 在庫数 -->
										<td
											v-if="isBeforeToday"
											rowspan="2"
											:class="{
												'negative-number': rubberTotalQuantity(rubber.id) < 0,
												'sticky-03': fixed,
												'not-sticky-03': !fixed,
											}"
										>
											{{ rubberTotalQuantity(rubber.id) }}
										</td>
										<!--　月末在庫数(見込み) -->
										<td
											v-if="isBeforeToday"
											rowspan="2"
											:class="{
												'sticky-04': fixed,
												'not-sticky-04': !fixed,
											}"
										>
											{{ plannedRubberTotalQuantity(rubber.id) }}
										</td>
										<!--　入庫合計 -->
										<td
											:class="{
												'sticky-05': fixed,
												'not-sticky-05': !fixed,
											}"
										>
											{{ rubberTotalReceivings(rubber.id) }}
										</td>
										<!--　入庫合計(見込み) -->
										<td
											:class="{
												'sticky-06': fixed,
												'not-sticky-06': !fixed,
											}"
										>
											{{ plannedRubberTotalReceivings(rubber.id) }}
										</td>
										<td
											:class="{
												'sticky-07': fixed,
												'not-sticky-07': !fixed,
											}"
										>
											入庫
										</td>
										<td
											class="pointer"
											v-for="date in scheduleDates"
											:key="date.id"
											@click="openRubberReceivingShowDialog(rubber, date, receiving_shippings)"
										>
											<span
												:class="{
													future_number: date >= today,
													unreceived:
														rubberReceivingQuantity(date, rubber.id).notReceived && date < today,
												}"
											>
												{{ rubberReceivingQuantity(date, rubber.id).quantity }}
											</span>
										</td>
									</tr>
									<tr>
										<!-- 出庫合計 -->
										<td :class="{ 'sticky-05': fixed }">
											{{ rubberTotalShippings(rubber.id) }}
										</td>
										<!-- 出庫合計(見込み) -->
										<td :class="{ 'sticky-06': fixed }">
											{{ plannedRubberTotalShippings(rubber.id) }}
										</td>
										<td :class="{ 'sticky-07': fixed }">出庫</td>
										<td
											class="pointer"
											@click="openRubberShippingShowDialog(rubber, date, receiving_shippings)"
											v-for="date in scheduleDates"
											:key="date.id"
										>
											<span
												:class="{
													future_number: date >= today,
													unreceived:
														rubberShippingQuantity(date, rubber.id).notReceived && date < today,
												}"
											>
												{{ rubberShippingQuantity(date, rubber.id).quantity }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
						<PaginationModule
							:pagination="pagination"
							@get-page="getPage($event)"
						></PaginationModule>
					</div>
				</template>
				<template v-else>
					<Loading :isLoading="loading" />
				</template>
			</template>
		</CommonFlame>
		<RubberReceivingShowDialog
			:authority="authority"
			:rubber="rubber"
			:dialog.sync="showRubberReceivingShowDialog"
			:receiving_shippings="receiving_shippings"
			:selectedDate="selectedDate"
			@reload-new-index="receiving_shippings.push($event)"
			@reload-delete-index="getDeletedIndex"
		/>
		<RubberShippingShowDialog
			:authority="authority"
			:rubber="rubber"
			:dialog.sync="showRubberShippingShowDialog"
			:shippingShowParams="shippingShowParams"
			:receiving_shippings="receiving_shippings"
			:selectedDate="selectedDate"
			:today="today"
			@reload-new-index="receiving_shippings.push($event)"
			@reload-delete-index="getDeletedIndex"
		/>
		<RubberShowDialog
			:dialog.sync="showRubberShowDialog"
			:authority="authority"
			:rubber.sync="rubber"
		/>
		<RubberCustomerCompanyIndexDialog :dialog.sync="showRubberCustomerCompanyIndexDialog" />
	</div>
</template>

<script>
import moment from "moment"
import "moment/locale/ja"
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import PaginationModule from "../../modules/PaginationModule.vue"
import CommonFlame from "../shared/CommonFlame.vue"
import FunctionTitle from "../shared/FunctionTitle.vue"
import RubberStockSearchForm from "./components/RubberStockSearchForm.vue"
import RubberShippingShowDialog from "./components/RubberShippingShowDialog.vue"
import RubberReceivingShowDialog from "./components/RubberReceivingShowDialog.vue"
import RubberShowDialog from "./components/RubberShowDialog.vue"
import RubberCustomerCompanyIndexDialog from "./components/RubberCustomerCompanyIndexDialog.vue"
import Loading from "../shared/IndeterminateLoadingView.vue"

export default {
	// TODO ShippingとReceivingのコンポーネントは共通化を考慮する
	components: {
		CommonFlame,
		FunctionTitle,
		PaginationModule,
		RubberStockSearchForm,
		RubberReceivingShowDialog,
		RubberShippingShowDialog,
		RubberShowDialog,
		RubberCustomerCompanyIndexDialog,
		Loading,
	},
	filters: {
		dateFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("MM/DD(dd)")
		},
		monthFormatter(date) {
			if (!date) return
			moment.locale("ja")
			return moment(date).format("YYYY年MM月")
		},
	},
	data() {
		return {
			search_title: "ゴム生地在庫一覧検索",
			pageTitle: "ゴム生地一覧",
			mainTitle: "",
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
			q: {
				name_cont: null,
				order_individual_infos_ordered_product_id_eq_any: null,
			},
			month: null,
			currentMonth: null,
			scheduleDates: [],
			rubber: null,
			rubbers: [],
			fixed: false,
			authority: false,
			showSearchForm: true,
			showRubberShowDialog: false,
			showRubberCustomerCompanyIndexDialog: false,
			showRubberShippingShowDialog: false,
			showRubberReceivingShowDialog: false,
			carry_overs: [],
			receiving_shippings: [],
			selectedDate: null,
			shippingShowParams: {
				shippingPlannedQuantity: null,
				totalPlannedQuantity: null,
			},
			loading: false,
			today: null,
			formattedCurrentMonth: null,
		}
	},
	mounted() {
		const moment = require("moment")
		this.setMonthTitle()
		this.setSchedules()
		this.setQuery()
		const page = this.$route.query.page ? this.$route.query.page : 1
		if (
			this.$route.query.name_cont ||
			this.$route.query.current_date ||
			this.$route.query.order_individual_infos_ordered_product_id_eq_any
		) {
			const rubber_name_query = this.$route.query.name_cont
			const current_date_query = this.$route.query.current_date
			const ordered_product_id_query =
				this.$route.query.order_individual_infos_ordered_product_id_eq_any
			this.month = this.$route.query.current_date
			this.fetchRubberStock(page, rubber_name_query, current_date_query, ordered_product_id_query)
		}
		this.today = moment().format("YYYY-MM-DD")
		this.formattedCurrentMonth = moment(this.currentMonth).format("YYYY-MM-DD")
	},
	// TODO receivingとshippingは引数でとり、メソッドを共通化する
	methods: {
		setQuery() {
			const query = this.$route.query
			Object.keys(this.$route.query).forEach((query_key) => {
				if (query[query_key] && query_key != "page" && query_key != "current_date") {
					this.q[query_key] = this.formatQuery(query[query_key])
				}
			})
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
		getDeletedIndex(receiving_shipping_id) {
			this.receiving_shippings = this.receiving_shippings.filter(
				(v) => v.id !== receiving_shipping_id
			)
		},
		openRubberShippingShowDialog(rubber, date) {
			this.rubber = rubber
			this.shippingShowParams.shippingPlannedQuantity = this.rubberShippingQuantity(date, rubber.id)
			this.shippingShowParams.totalPlannedQuantity = this.rubberTotalQuantity(rubber.id)
			this.selectedDate = date
			this.showRubberShippingShowDialog = true
		},
		openRubberReceivingShowDialog(rubber, date, receiving_shippings) {
			this.rubber = rubber
			this.selectedDate = date
			this.receiving_shippings = receiving_shippings
			this.showRubberReceivingShowDialog = true
		},
		rubberShippingQuantity(date, rubber_id) {
			const array = this.receiving_shippings.filter((receiving_shipping) => {
				return (
					receiving_shipping.planned_operation_date == date &&
					receiving_shipping.target_id == rubber_id &&
					receiving_shipping.movement_type == "shipping"
				)
			})
			const total_quantity = array.reduce((sum, element) => {
				return sum + element.planned_quantity
			}, 0)

			const unreceived = array.some((value) => {
				return value.situation == "planned"
			})

			if (total_quantity == 0) {
				return ""
			} else {
				return { quantity: total_quantity, notReceived: unreceived }
			}
		},
		rubberReceivingQuantity(date, rubber_id) {
			const array = this.receiving_shippings.filter((receiving_shipping) => {
				return (
					receiving_shipping.planned_operation_date == date &&
					receiving_shipping.target_id == rubber_id &&
					receiving_shipping.movement_type == "receiving"
				)
			})
			const total_quantity = array.reduce((sum, element) => {
				return sum + element.planned_quantity
			}, 0)

			const unreceived = array.some((value) => {
				return value.situation == "planned"
			})

			if (total_quantity == 0) {
				return ""
			} else {
				return { quantity: total_quantity, notReceived: unreceived }
			}
		},
		rubberTotalQuantity(rubber_id) {
			return (
				this.rubberCarryOver(rubber_id) -
				this.rubberTotalShippings(rubber_id) +
				this.rubberTotalReceivings(rubber_id)
			)
		},
		plannedRubberTotalQuantity(rubber_id) {
			return (
				this.rubberCarryOver(rubber_id) -
				this.plannedRubberTotalShippings(rubber_id) +
				this.plannedRubberTotalReceivings(rubber_id)
			)
		},
		plannedRubberTotalShippings(rubber_id) {
			// 今日以前の数量
			const before_today_array = this.receiving_shippings.filter((receiving_shipping) => {
				return (
					receiving_shipping.target_id == rubber_id &&
					receiving_shipping.movement_type == "shipping" &&
					receiving_shipping.actual_operation_date <= this.today &&
					receiving_shipping.situation !== "planned"
				)
			})
			const before_today_quantity = before_today_array.reduce((sum, element) => {
				return sum + element.actual_quantity
			}, 0)

			// 今日以降の数量
			const after_today_array = this.receiving_shippings.filter((receiving_shipping) => {
				return (
					receiving_shipping.target_id == rubber_id &&
					receiving_shipping.movement_type == "shipping" &&
					receiving_shipping.planned_operation_date > this.today &&
					receiving_shipping.situation == "planned"
				)
			})
			const after_today_quantity = after_today_array.reduce((sum, element) => {
				return sum + element.planned_quantity
			}, 0)

			return before_today_quantity + after_today_quantity
		},
		plannedRubberTotalReceivings(rubber_id) {
			// 今日以前の数量
			const before_today_array = this.receiving_shippings.filter((receiving_shipping) => {
				return (
					receiving_shipping.target_id == rubber_id &&
					receiving_shipping.movement_type == "receiving" &&
					receiving_shipping.actual_operation_date <= this.today &&
					receiving_shipping.situation !== "planned"
				)
			})
			const before_today_quantity = before_today_array.reduce((sum, element) => {
				return sum + element.actual_quantity
			}, 0)

			// 今日以降の数量
			const after_today_array = this.receiving_shippings.filter((receiving_shipping) => {
				return (
					receiving_shipping.target_id == rubber_id &&
					receiving_shipping.movement_type == "receiving" &&
					receiving_shipping.planned_operation_date > this.today &&
					receiving_shipping.situation == "planned"
				)
			})

			const after_today_quantity = after_today_array.reduce((sum, element) => {
				return sum + element.planned_quantity
			}, 0)

			return before_today_quantity + after_today_quantity
		},
		rubberTotalShippings(rubber_id) {
			const array = this.receiving_shippings.filter((receiving_shipping) => {
				return (
					receiving_shipping.target_id == rubber_id &&
					receiving_shipping.movement_type == "shipping"
				)
			})
			const total_quantity = array.reduce((sum, element) => {
				return sum + element.actual_quantity
			}, 0)

			return total_quantity
		},
		rubberTotalReceivings(rubber_id) {
			const array = this.receiving_shippings.filter((receiving_shipping) => {
				return (
					receiving_shipping.target_id == rubber_id &&
					receiving_shipping.movement_type == "receiving"
				)
			})
			const total_quantity = array.reduce((sum, element) => {
				return sum + element.actual_quantity
			}, 0)
			return total_quantity
		},
		rubberCarryOver(component_id) {
			const array = this.carry_overs.filter((carry_over) => {
				return carry_over.target_id == component_id
			})
			const total_quantity = array.reduce((sum, element) => {
				return sum + element.quantity
			}, 0)
			return total_quantity
		},
		openRubberCustomerCompanyIndexDialog() {
			this.showRubberCustomerCompanyIndexDialog = true
		},
		openRubberShowDialog(rubber) {
			this.rubber = rubber
			this.showRubberShowDialog = true
		},
		getPage(page) {
			this.fetchRubberStock(page)
			this.$router.push({
				name: "rubber_index",
				query: {
					name_cont: this.q.name_cont,
					order_individual_infos_ordered_product_id_eq_any:
						this.q.order_individual_infos_ordered_product_id_eq_any,
					current_date: this.currentMonth,
					page: page,
				},
			})
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			})
		},
		setMonthTitle() {
			let now = new Date()
			this.currentMonth = now
		},
		setSchedules() {
			let schedules = []
			const daysInMonth = moment(this.currentMonth).daysInMonth()
			const month = moment(this.currentMonth).month() + 1
			const year = moment(this.currentMonth).year()
			for (let i = 1; i <= daysInMonth; i++) {
				schedules.push(moment(`${year}-${month}-${i}`).format("YYYY-MM-DD"))
			}
			this.scheduleDates = schedules
		},
		previousMonth() {
			this.currentMonth = moment(this.currentMonth).add(-1, "month").format("YYYY-MM-DD")
			this.formattedCurrentMonth = this.currentMonth
			this.$router.push({
				name: "rubber_index",
				query: {
					name_cont: this.q.name_cont,
					order_individual_infos_ordered_product_id_eq_any:
						this.q.order_individual_infos_ordered_product_id_eq_any,
					current_date: this.currentMonth,
				},
			})

			this.setSchedules()
			this.month = moment(this.currentMonth).format("YYYY-MM")
			this.fetchRubberStock(this.pagination.current)
		},
		nextMonth() {
			this.currentMonth = moment(this.currentMonth).add(1, "month").format("YYYY-MM-DD")
			this.formattedCurrentMonth = this.currentMonth
			this.$router.push({
				name: "rubber_index",
				query: {
					name_cont: this.q.name_cont,
					order_individual_infos_ordered_product_id_eq_any:
						this.q.order_individual_infos_ordered_product_id_eq_any,
					current_date: this.currentMonth,
				},
			})
			this.setSchedules()
			this.month = moment(this.currentMonth).format("YYYY-MM")
			this.fetchRubberStock(this.pagination.current)
		},
		back() {
			this.showSearchForm = true
			if (this.month) {
				this.month = moment(this.month).format("YYYY-MM")
			}
			this.q.name_cont = null
			this.q.order_individual_infos_ordered_product_id_eq_any = null
			this.$router.push({ query: null })
		},
		resetSearchForm() {
			this.showSearchForm = false
		},
		feachTargetMonth(target_month) {
			let search_month = new Date(target_month)
			this.currentMonth = search_month

			let schedules = []
			let daysInMonth = moment(target_month).daysInMonth()
			let month = moment(target_month).month() + 1
			let year = moment(target_month).year()
			for (let i = 1; i <= daysInMonth; i++) {
				schedules.push(moment(`${year}-${month}-${i}`).format("YYYY-MM-DD"))
			}
			this.scheduleDates = schedules
		},
		searchRubberStock(page, rubber_name, current_date_query, ordered_product_id_query) {
			this.fetchRubberStock(page, rubber_name, current_date_query, ordered_product_id_query)
			this.$router.push({
				name: "rubber_index",
				query: {
					name_cont: this.q.name_cont,
					order_individual_infos_ordered_product_id_eq_any:
						this.q.order_individual_infos_ordered_product_id_eq_any,
					current_date: this.currentMonth,
					page: page,
				},
			})
		},
		fetchRubberStock(page, rubber_name, current_date_query, ordered_product_id_query) {
			this.loading = true
			authenticate.authenticateUser()
			const headers = authenticate.setHeader()

			if (rubber_name) {
				this.q.name_cont = rubber_name
			}

			if (this.month) {
				this.feachTargetMonth(this.month)
			}

			if (current_date_query) {
				this.currentMonth = current_date_query
			}

			if (ordered_product_id_query) {
				this.q.order_individual_infos_ordered_product_id_eq_any = ordered_product_id_query
			}

			const date_params = this.currentMonth

			axios
				.get(`/erp/v1/rubber/stocks`, {
					headers,
					params: { q: this.q, page: page, current_date: date_params },
				})
				.then((res) => {
					this.resetSearchForm()
					this.rubbers = res.data.rubbers
					this.receiving_shippings = res.data.receiving_shippings
					this.carry_overs = res.data.carry_overs
					this.pagination = res.data.pagination
					this.authority = res.data.authority
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
				.finally(() => this.$nextTick(() => (this.loading = false)))
		},
	},
	computed: {
		stock() {
			// 当月であれば'現在庫'を返し、過去であれば'月末在庫数'を返す
			const current_month = moment(this.formattedCurrentMonth).format("YYYY-MM")
			const today = moment(this.today).format("YYYY-MM")
			if (current_month == today) {
				return "現在庫数"
			}
			if (current_month < today) {
				return "月末在庫数"
			}
		},
		isBeforeToday() {
			return this.formattedCurrentMonth <= this.today
		},
	},
}
</script>

<style scoped lang="scss">
@import "../../stylesheet/variable.scss";

.table-area {
	height: 590px;
	overflow-y: scroll;
	table {
		border-collapse: separate;
		text-align: center;
		max-height: 1000px;
	}
	th,
	td {
		border: 1px gray solid;
		padding: 3px;
		font-weight: bold;
	}
	th {
		background-color: $sub-color;
		color: #fff;
		min-width: 110px;
		text-align: center;
		position: sticky;
		top: 0;
	}
	.main-color {
		background-color: $main-color;
		position: sticky;
		top: 0;
		z-index: 3;
	}
}

.pointer {
	cursor: pointer;
}

i {
	margin-right: 5px;
}

.d-flex {
	height: 50px;
	margin-top: 8px;
}

.month {
	font-size: 25px;
	font-weight: bold;
	margin-left: 7px;
}

.sticky-01 {
	position: sticky;
	left: 0px;
	z-index: 2;
	min-width: 200px;
}

.sticky-02 {
	position: sticky;
	left: 200px;
	z-index: 2;
	min-width: 200px;
}

.sticky-03 {
	position: sticky;
	left: 218px;
	z-index: 2;
	min-width: 100px;
}
.sticky-04 {
	position: sticky;
	left: 326px;
	z-index: 2;
	min-width: 100px;
}

.sticky-05 {
	position: sticky;
	left: 434px;
	z-index: 2;
	min-width: 100px;
}

.sticky-06 {
	position: sticky;
	left: 200px;
	z-index: 2;
	min-width: 100px;
}

.sticky-07 {
	position: sticky;
	left: 300px;
	z-index: 2;
	min-width: 100px;
}

.not-sticky-01 {
	z-index: 2;
	min-width: 200px;
}

.not-sticky-02 {
	z-index: 2;
	min-width: 200px;
}

.not-sticky-03 {
	z-index: 2;
	min-width: 100px;
}
.not-sticky-04 {
	z-index: 2;
	min-width: 100px;
}

.not-sticky-05 {
	z-index: 2;
	min-width: 100px;
}

.not-sticky-06 {
	z-index: 2;
	min-width: 100px;
}

.not-sticky-07 {
	z-index: 2;
	min-width: 100px;
}

tr:nth-child(even) {
	background: #e0ffff;
}

.negative-number {
	color: red;
}

.future_number {
	color: #8d99e0;
}

.unreceived {
	color: red;
}
</style>
